module.exports = __webpack_public_path__ + "img/RG.43feb11c.png";